import Controller from '@ember/controller';
import { get, set } from '@ember/object';
import { sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  contactsCache: service(),
  fundsService: service(),
  router: service(),

  error: null,

  reset() {
    set(this, 'error', null);
  },

  sortBy: Object.freeze(['name:asc']),
  sortedContacts: sort('model.contacts', 'sortBy'),

  addContactsToGroup(groupName) {
    return new Promise((resolve, reject) => {
      get(this, 'model.contacts')
        .reduce(function (promise, contact) {
          return promise.then(function () {
            contact.groups = [...contact.groups, groupName];
            return contact.save();
          });
        }, Promise.resolve())
        .then(
          () => {
            this.contactsCache.incrementProperty('groupsCacheIndex');
            resolve();
          },
          (error) => {
            reject(error);
          },
        );
    });
  },

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    let groupName = get(changeset, 'name');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        yield this.fundsService.confirmValidFundToken();
        yield this.addContactsToGroup(groupName);
        this.router.transitionTo('funds.fund.groups.group', groupName);
      } catch (error) {
        set(this, 'error', error);
      }
    }
  }).drop(),
});
